
$(document).ready(function () {



   // Lazy Load the poster

    const $videos = $(".vid_blk video");

  const videoObserver = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      const $video = $(entry.target);
      $video.attr({
        preload: "auto",
        muted: true,
        playsinline: true
      });

      generatePosterAfter5Sec($video);

      obs.unobserve(entry.target);
    });
  }, { rootMargin: "100px" });

  $videos.each(function () {
    videoObserver.observe(this);
  });

  function generatePosterAfter5Sec($video) {
    const video = $video.get(0);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    let captured = false;

    $video.attr("crossorigin", "anonymous");

    // Try autoplay silently to ensure timeupdate fires
    const playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.catch(err => console.warn("Autoplay blocked:", err));
    }

    $video.on("timeupdate", function () {
      if (captured) return;

      if (video.currentTime >= 1) {
        try {
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
          $video.attr("poster", canvas.toDataURL("image/jpeg"));
          captured = true;
          console.log("✅ Poster generated at 5s");

          // Pause video after capture (optional)
          video.pause();
        } catch (err) {
          console.warn("⚠️ Unable to capture frame — likely CORS issue:", err);
        }
      }
    });
  }


  // Video auto play and hover effect 

  $(document).on("mouseenter", ".vid_blk", function () {
    $(".vid_blk video").trigger("pause");
    $(".vid_blk .video_cta").fadeIn();

    $(this).find(".video_cta").fadeOut();
    $(this).find("video").prop("muted", true).trigger("play");
  });

  $(document).on("click", ".vid_blk", function (e) {
    e.stopPropagation();
    const clickedVideo = $(this).find("video").get(0);

    const isPlaying = clickedVideo && !clickedVideo.paused && !clickedVideo.ended;

    if (isPlaying) {
      clickedVideo.pause();
      clickedVideo.currentTime = 0;
      $(clickedVideo).removeAttr("controls").prop("muted", true);
      $(this).find(".video_cta").fadeIn();
    } else {
      $(".vid_blk video").each(function () {
        if (this !== clickedVideo) {
          this.pause();
          this.currentTime = 0;
          $(this).removeAttr("controls").prop("muted", true);
        }
      });

      $(".vid_blk .video_cta").fadeIn();

      $(clickedVideo)
        .prop("muted", false)
        .attr("controls", true)
        .trigger("play");

      $(this).find(".video_cta").fadeOut();
    }
  });

  $(document).on("click", ".vid_blk .video_cta", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).closest(".vid_blk").trigger("click");
  });

  $(document).on("mouseleave", ".vid_blk", function () {
    const vid = $(this).find("video").get(0);
    if (vid) {
      vid.pause();
      vid.currentTime = 0; // reset to start
      $(vid).removeAttr("controls").prop("muted", true);
    }
    $(this).find(".video_cta").fadeIn();
  });

  $('#slick-quick-review').slick({
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    pauseOnHover: true,
    cssEase: 'linear',	
    slidesToShow: 5,
    variableWidth: true,
    speed: 12000,
    slidesToScroll: 1,
    responsive: [
        {
        breakpoint: 1199,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 570,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });

  $('.slick-quick-user-slider').slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 600,
    pauseOnHover: true,
    cssEase: 'linear',
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2.4,
          slidesToScroll: 1,
        }
      }
    ]
  });

  $(".slick-custom-testimonial").slick({
      dots: false,
      arrows: true,
      infinite: true,
      autoplay: false,
      speed: 600,
      autoplaySpeed: 4000,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });
});


// Prodcut Page Result circular Progress 

document.addEventListener("DOMContentLoaded", () => {
  const progressBars = document.querySelectorAll(".progress-wrap");

  const animateProgress = (el) => {
    const circle = el.querySelector(".progress");
    const percent = el.getAttribute("data-percent");

    const radius = 30;
    const circumference = 2 * Math.PI * radius;

    const offset = circumference - (percent / 100) * circumference;

    circle.style.strokeDasharray = circumference;
    circle.style.strokeDashoffset = circumference;

    setTimeout(() => {
      circle.style.strokeDashoffset = offset;
    }, 200);
  };

  // 🔥 Run on page load (for visible elements)
  progressBars.forEach(el => {
    const rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight) {
      animateProgress(el);
      el.classList.add("animated");
    }
  });

  // 🔥 Run on scroll (viewport trigger)
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !entry.target.classList.contains("animated")) {
        animateProgress(entry.target);
        entry.target.classList.add("animated");
      }
    });
  }, { threshold: 0.5 });

  progressBars.forEach(el => observer.observe(el));
});

document.addEventListener('DOMContentLoaded', function () {

  const promoBar = document.getElementById('promo-bar');

  const hoursEl = document.getElementById('promo-hours');
  const minutesEl = document.getElementById('promo-minutes');
  const secondsEl = document.getElementById('promo-seconds');

  if (
    !promoBar ||
    !hoursEl ||
    !minutesEl ||
    !secondsEl
  ) {
    return;
  }

  /*
   * SHOW BAR ON SCROLL
   */
  window.addEventListener('scroll', function () {

    if (window.scrollY > 600) {
      promoBar.classList.add('show');
    } else {
      promoBar.classList.remove('show');
    }

  });

  /*
   * TIMER
   * Resets every midnight
   */

  function getSecondsUntilMidnight() {

    const now = new Date();

    const midnight = new Date();

    midnight.setHours(24, 0, 0, 0);

    return Math.floor(
      (midnight.getTime() - now.getTime()) / 1000
    );
  }

  let remainingSeconds = getSecondsUntilMidnight();

  function updateTimer() {

    const hours = Math.floor(
      remainingSeconds / 3600
    );

    const minutes = Math.floor(
      (remainingSeconds % 3600) / 60
    );

    const seconds = remainingSeconds % 60;

    hoursEl.textContent =
      String(hours).padStart(2, '0');

    minutesEl.textContent =
      String(minutes).padStart(2, '0');

    secondsEl.textContent =
      String(seconds).padStart(2, '0');

    if (remainingSeconds <= 0) {
      remainingSeconds = getSecondsUntilMidnight();
    } else {
      remainingSeconds--;
    }

  }

  updateTimer();

  setInterval(updateTimer, 1000);

});